import React from 'react';
import { Ornament } from './Ornament';
import { PlaylistCta } from './PlaylistCta';
import { Reveal } from './Reveal';
import { SCHEDULE } from '../data/invitation';
export function Schedule() {
  return <section className="w-full bg-paper-100 px-6 py-24 sm:px-10 sm:py-32 lg:px-16" data-id="element-115" data-mp="r4na5tu8kcds">
      <div className="mx-auto max-w-5xl" data-id="element-116" data-mp="w3qf7ea7uilr">
        <Reveal className="mb-20 sm:mb-24" data-id="element-117" data-mp="w3gqrv4tkji6">
          <PlaylistCta data-id="element-118" data-mp="3ulngoq8hoezf" />
        </Reveal>

        <Reveal data-id="element-119" data-mp="3umxedebfjl5j">
          <div className="flex items-baseline justify-between border-b border-ink-900/10 pb-4" data-id="element-120" data-mp="3ungldzzjkp4s">
            <p className="text-[0.65rem] uppercase tracking-label text-ink-400" data-id="element-121" data-mp="3fukgf47j0rm">Potek dneva</p>
            <p className="font-serif text-sm italic text-ink-400" data-id="element-122" data-mp="8cujw76jx59r">dva dela, en dan</p>
          </div>
        </Reveal>

        <div className="mt-12 grid gap-px overflow-hidden border border-ink-900/10 bg-ink-900/10 lg:grid-cols-2" data-id="element-123" data-mp="dbfkw8tmnsz9">
          {SCHEDULE.map((m, i) => <Reveal key={m.time} delay={i * 0.06} className="h-full" data-id="element-124" data-mp="1orw0c256m9m4" data-mpi={i}>
              <article className="relative flex h-full flex-col overflow-hidden bg-paper-50 p-8 sm:p-12" data-id="element-125" data-mp="1d3rovujo4pt8">
                <span aria-hidden="true" className="pointer-events-none absolute -bottom-8 right-2 select-none font-serif text-[9rem] font-light leading-none text-ink-900/[0.04]" data-id="element-126" data-mp="1856qm0nz8g7f">
                  {m.index}
                </span>
                <p className="relative text-[0.65rem] uppercase tracking-label text-accent-500" data-id="element-127" data-mp="u55lua4lcomo">
                  {m.index} del
                </p>
                <p className="relative mt-6 font-serif text-6xl font-light leading-none text-ink-900 sm:text-7xl" data-id="element-128" data-mp="pdnm1peb0u3a">
                  {m.time}
                </p>
                <h2 className="relative mt-4 font-serif text-2xl font-light italic text-ink-800 sm:text-3xl" data-id="element-129" data-mp="ge0vxzr0zapj">
                  {m.title}
                </h2>
                <p className="relative mt-6 font-serif text-lg leading-relaxed text-ink-700 sm:text-xl" data-id="element-130" data-mp="bdwadvb9fpsg">
                  {m.text}
                </p>
                {m.note && <p className="relative mt-auto border-t border-dotted border-ink-900/20 pt-6 text-sm italic leading-relaxed text-ink-500" data-id="element-131" data-mp="3svs5jvs3h5ww">
                    {m.note}
                  </p>}
              </article>
            </Reveal>)}
        </div>

        <Reveal delay={0.1} data-id="element-132" data-mp="3nxgz7v10ddjf">
          <Ornament className="mt-16" data-id="element-133" data-mp="3nyik0r7tteec" />
          <p className="mx-auto mt-10 max-w-2xl text-center font-serif text-2xl font-light italic leading-snug text-ink-900 sm:text-3xl" data-id="element-134" data-mp="fiqgm82f34rs">
            Za hrano in pijačo bo poskrbljeno. Za razplet večera nekoliko manj.
          </p>
        </Reveal>
      </div>
    </section>;
}